module.exports = __webpack_public_path__ + "assets/img/tsgn4.d47b6b2a.jpg";